import { FormikProps, getIn } from 'formik'
import { useId } from 'react'
import { Label } from '../Label/Label'
import { ErrorLabel, TextArea } from '..'
import { FontSize } from '../../../_metronic/helpers'
import { useT } from '_metronic/i18n/Metronici18n'

interface FormTextAreaProps {
  label?: string
  name: string
  placeholder?: string
  formik: FormikProps<any>
  isDisabled?: boolean
  isRequired?: boolean
  rows?: number
  cols?: number
  className?: string
  isPlainText?: boolean
  shouldExpand?: boolean
  onReset?: () => void
  readOnly?: boolean
  infoText?: string
  labelSize?: FontSize
  highlight?: boolean
  entity?: string
}

export const FormTextArea: React.FC<FormTextAreaProps> = ({
  label,
  name,
  placeholder,
  formik,
  isDisabled = false,
  isRequired = false,
  rows = 5,
  cols = 30,
  className = '',
  isPlainText = false,
  shouldExpand = true,
  onReset,
  readOnly = false,
  infoText,
  labelSize,
  highlight,
  entity,
}) => {
  const { t } = useT()
  const errorMessage = getIn(formik.errors, name)
  const touched = getIn(formik.touched, name)
  const value = getIn(formik.values, name)

  const resolvedLabel = label ?? (entity ? t(`${entity}.label`) : undefined)

  const inputId = `${name}-${useId()}`

  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    onReset?.()
    formik.setFieldValue(name, e.target.value)
  }

  return (
    <div className={`${className}`}>
      {resolvedLabel && (
        <Label
          className='mb-2'
          htmlFor={inputId}
          isRequired={isRequired}
          size={labelSize}
          infoText={infoText}
          highlight={highlight}
        >
          {resolvedLabel}
        </Label>
      )}
      <TextArea
        id={inputId}
        value={value}
        onChange={handleChange}
        onFocus={() => formik.setFieldTouched(name, true)}
        placeholder={placeholder}
        rows={rows}
        cols={cols}
        className={touched && errorMessage ? 'is-invalid' : ''}
        isPlainText={isPlainText}
        shouldExpand={shouldExpand}
        disabled={formik.isSubmitting || isDisabled}
        readOnly={readOnly}
        entity={entity}
      />
      {touched && errorMessage && <ErrorLabel>{errorMessage}</ErrorLabel>}
    </div>
  )
}
